import ru from './ru.json';

export const locales = {
  ru,
};
